class CoreHeaderController {
    constructor(shopperService, shopPageStateService, moveFocus) {
        this.shopperService = shopperService;
        this.shopPageStateService = shopPageStateService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.sfSearchActive = false;
    }

    isMenuOpen() {
        return this.shopPageStateService.smallFormatMenuOpen;
    }

    toggleOffscreenMenu(isOpen = !this.shopPageStateService.smallFormatMenuOpen) {
        this.shopPageStateService.smallFormatMenuOpen = isOpen;

        if (this.shopPageStateService.smallFormatMenuOpen) {
            this.moveFocus('#smallMenu');
        }
    }

    hideMenu() {
        if (this.isMenuOpen()) {
            this.toggleOffscreenMenu();
        }
    }
}

const coreHeaderComponentDefinition = {
    controller: ['ShopperService', 'ShopPageStateService', 'MoveFocus', CoreHeaderController],
    template: require('./core-header.component.html').trim(),
};

module.exports = {
    CoreHeaderController,
    coreHeaderComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/core-header.component.js